import en from './en'
import es from './es'

const languages = { en, es }

export default (locale) => {
  const lang = locale.split('-')[0]
  return languages[lang]
}
